import { Injectable, InjectionToken, Inject, Optional } from "@angular/core";
import Compressor from "compressorjs";

/**
 * @interface Object Option type interface to configure image compressor options
 */
export interface ImageCompressOption {
  /**
   * * File size limit (bytes).
   */
  convertSize?: number;
  /**
   * * Quality of output image (number between 0 and 1).
   */
  quality?: number;
}

// * InjectionToken
export const IMAGE_COMPRESS_CONFIG = new InjectionToken<ImageCompressOption>(
  "ifca-image-compress "
);

/**
 * A service to compress image and reduce file size.
 *
 * Service Dependencies :-
 * * image-compressor.js        : Image compressor [https://www.npmjs.com/package/image-compressor.js]
 *
 * @interface ImageCompressOption? Configure compressor option by registering provider InjectionToken IMAGE_COMPRESS_CONFIG with useValue property.
 *
 * @default ImageCompressOption Default option value. convertSize 25000000, quality 0.8
 */
@Injectable()
export class ImageCompressService {
  constructor(
    @Optional()
    @Inject(IMAGE_COMPRESS_CONFIG)
    private config: ImageCompressOption
  ) {
    this.config = this.config || {};
    this.config.convertSize = this.config.convertSize ?? 25000000; // bytes
    this.config.quality = this.config.quality ?? 0.8;
  }

  compressImage(imageFile: File, option: ImageCompressOption = {}) {
    return new Promise<File>((resolve, reject) => {
      let optionConfig: ImageCompressOption = Object.assign(
        {},
        this.config,
        option
      );

      new Compressor(imageFile, {
        quality: optionConfig.quality,
        convertSize: optionConfig.convertSize,
        success: (result) => {
          let file = new File([result], imageFile.name, {
            type: imageFile.type,
          });
          resolve(file);
        },
        error: (err) => {
          console.error(err);
          reject("Failed to compress image.");
        },
      });
    });
  }
}
